import React, { useState } from 'react';
import { IconButton, Popover, Box } from '@mui/material';
import { Help } from '@mui/icons-material';

const RichTooltip = ({ children, icon = null, padding = 2, inline = false }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'popover-tooltip' : undefined;

    return (
        <Box component={inline ? 'span' : undefined}>
            <IconButton
                onClick={handleClick}
                color="info"
                size="small"
            >
                {icon ?? <Help fontSize="inherit" />}
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <Box sx={{ padding }}>
                    {children}
                </Box>
            </Popover>
        </Box>
    );
};

export default RichTooltip;